export class NurseryModel {

    public name: string;
    public address: string;
    public uuid: string;
    public imageURL: string;
    public latitude: number;
    public longitude: number;
    public visible: boolean;
    public versionNumber: string;

    constructor(value: unknown) {
        this.uuid = value["uuid"];
        this.name = value["name"];
        this.address = value["address"];
        this.latitude = value["latitude"];
        this.longitude = value["longitude"];
        this.visible = value["visible"];
        this.versionNumber = value["version_number"];

    }
}
